import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["existingTab", "newTab", "existingPanel", "newPanel", "mode", "phone", "operatorId", "lookupMessage"];
  static values = { searchUrl: String };

  connect() {
    if (!this.hasModeTarget) return;

    this.modeTarget.value === "new" ? this.showNew() : this.showExisting();
    if (this.modeTarget.value === "existing" && this.hasPhoneTarget && this.phoneTarget.value.length === 11) this.lookup();
  }

  disconnect() {
    clearTimeout(this.lookupTimer);
    this.pendingSearch?.abort();
  }

  showExisting() {
    this.selectMode("existing");
  }

  showNew() {
    if (this.hasNewPanelTarget) this.selectMode("new");
  }

  selectMode(mode) {
    this.modeTarget.value = mode;
    this.existingPanelTarget.classList.toggle("hidden", mode !== "existing");
    if (this.hasNewPanelTarget) this.newPanelTarget.classList.toggle("hidden", mode !== "new");
    this.existingTabTarget.classList.toggle("btn-primary", mode === "existing");
    this.existingTabTarget.classList.toggle("btn-outline", mode !== "existing");
    if (this.hasNewTabTarget) {
      this.newTabTarget.classList.toggle("btn-primary", mode === "new");
      this.newTabTarget.classList.toggle("btn-outline", mode !== "new");
    }
    this.element.querySelectorAll("[data-partner-form-existing-required]").forEach((field) => { field.required = mode === "existing"; });
    this.element.querySelectorAll("[data-partner-form-new-required]").forEach((field) => { field.required = mode === "new"; });
  }

  lookup() {
    if (!this.hasPhoneTarget || this.modeTarget.value !== "existing") return;

    const phone = this.phoneTarget.value.replace(/\D/g, "").slice(0, 11);
    if (this.phoneTarget.value !== phone) this.phoneTarget.value = phone;
    this.operatorIdTarget.value = "";
    clearTimeout(this.lookupTimer);
    this.pendingSearch?.abort();
    if (phone.length !== 11) {
      this.lookupMessageTarget.textContent = "输入 11 位手机号以匹配项目授权用户。";
      return;
    }
    this.lookupMessageTarget.textContent = "正在查找用户…";
    this.lookupTimer = setTimeout(() => this.search(phone), 300);
  }

  async search(phone) {
    this.pendingSearch = new AbortController();
    try {
      const url = new URL(this.searchUrlValue, window.location.origin);
      url.searchParams.set("phone_number", phone);
      const response = await fetch(url, { headers: { Accept: "application/json" }, signal: this.pendingSearch.signal });
      if (!response.ok) throw new Error("查询失败");
      const result = await response.json();
      if (this.phoneTarget.value !== phone || this.modeTarget.value !== "existing") return;
      this.operatorIdTarget.value = result.found ? result.user.id : "";
      this.lookupMessageTarget.textContent = result.found ? `找到用户：${result.user.nickname || phone}` : (result.message || "未找到项目授权用户");
    } catch (error) {
      if (error.name !== "AbortError") this.lookupMessageTarget.textContent = "查询失败，请稍后重试。";
    }
  }
}
